module.exports = __webpack_public_path__ + "static/media/trash-can-white.ee8aec2c.svg";